import { useState, useCallback, useEffect } from 'react';
import { KEYBOARD_KEYS, KEYBOARD_EVENTS } from '@CommonConstants';

const useKeyboardNavigation = (targetListLength, targetKey = '', keyboardEventType = KEYBOARD_EVENTS.KEY_DOWN) => {
  const [isKeyPressed, setIsKeyPressed] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const downHandler = useCallback(
    event => {
      const { key } = event;
      const isKeyPressedCondition = keyboardEventType === KEYBOARD_EVENTS.KEY_DOWN && targetKey && targetKey === key;

      if (key === KEYBOARD_KEYS.ARROW_DOWN) {
        event.preventDefault();
        setSelectedIndex(prevState => (prevState < targetListLength - 1 ? prevState + 1 : prevState));
      }

      if (key === KEYBOARD_KEYS.ARROW_UP) {
        event.preventDefault();
        setSelectedIndex(prevState => (prevState > 0 ? prevState - 1 : prevState));
      }

      if (isKeyPressedCondition) {
        event.preventDefault();
        setIsKeyPressed(true);
      }
    },
    [isKeyPressed, targetListLength, targetKey, keyboardEventType],
  );

  const upHandler = useCallback(
    event => {
      const { key } = event;
      const isKeyPressedCondition = keyboardEventType === KEYBOARD_EVENTS.KEY_UP && targetKey && targetKey === key;
      const isKeyUnPressedCondition = keyboardEventType === KEYBOARD_EVENTS.KEY_DOWN && targetKey && targetKey === key;

      if (isKeyPressedCondition) {
        event.preventDefault();
        setIsKeyPressed(true);
      } else if (isKeyUnPressedCondition) {
        event.preventDefault();
        setIsKeyPressed(false);
      }
    },
    [isKeyPressed, targetListLength, targetKey, keyboardEventType],
  );

  useEffect(() => {
    window.addEventListener(KEYBOARD_EVENTS.KEY_DOWN, downHandler);
    window.addEventListener(KEYBOARD_EVENTS.KEY_UP, upHandler);

    return () => {
      window.removeEventListener(KEYBOARD_EVENTS.KEY_DOWN, downHandler);
      window.removeEventListener(KEYBOARD_EVENTS.KEY_UP, upHandler);
    };
  }, [isKeyPressed, targetListLength, targetKey]);

  return { isKeyPressed, selectedIndex };
};

export default useKeyboardNavigation;

// import { useState, useCallback, useEffect } from 'react';
// import { KEYBOARD_KEYS, KEYBOARD_EVENTS } from '@CommonConstants';

// const useKeyboardNavigation = (targetListLength, targetKey = '', keyboardEventType = KEYBOARD_EVENTS.KEY_DOWN) => {
//   const [isKeyPressed, setIsKeyPressed] = useState(false);
//   const [selectedIndex, setSelectedIndex] = useState(0);

//   const downHandler = useCallback(
//     event => {
//       const { key } = event;
//       const isKeyPressedCondition = keyboardEventType === KEYBOARD_EVENTS.KEY_DOWN && targetKey && targetKey === key;

//       if (key === KEYBOARD_KEYS.ARROW_DOWN) {
//         event.preventDefault();
//         setSelectedIndex(prevState => (prevState < targetListLength - 1 ? prevState + 1 : prevState));
//       }

//       if (key === KEYBOARD_KEYS.ARROW_UP) {
//         event.preventDefault();
//         setSelectedIndex(prevState => (prevState > 0 ? prevState - 1 : prevState));
//       }

//       if (isKeyPressedCondition) {
//         event.preventDefault();
//         setIsKeyPressed(true);
//       }
//     },
//     [isKeyPressed, targetListLength, targetKey, keyboardEventType],
//   );

//   const upHandler = useCallback(
//     event => {
//       const { key } = event;
//       const isKeyPressedCondition = keyboardEventType === KEYBOARD_EVENTS.KEY_UP && targetKey && targetKey === key;
//       const isKeyUnPressedCondition = keyboardEventType === KEYBOARD_EVENTS.KEY_DOWN && targetKey && targetKey === key;

//       if (isKeyPressedCondition) {
//         event.preventDefault();
//         setIsKeyPressed(true);
//       } else if (isKeyUnPressedCondition) {
//         event.preventDefault();
//         setIsKeyPressed(false);
//       }
//     },
//     [isKeyPressed, targetListLength, targetKey, keyboardEventType],
//   );

//   useEffect(() => {
//     window.addEventListener(KEYBOARD_EVENTS.KEY_DOWN, downHandler);
//     window.addEventListener(KEYBOARD_EVENTS.KEY_UP, upHandler);

//     return () => {
//       window.removeEventListener(KEYBOARD_EVENTS.KEY_DOWN, downHandler);
//       window.removeEventListener(KEYBOARD_EVENTS.KEY_UP, upHandler);
//     };
//   }, [isKeyPressed, targetListLength, targetKey]);

//   return { isKeyPressed, selectedIndex };
// };

// export default useKeyboardNavigation;
